(() => {
  const init = (section) => {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    const items = [...section.querySelectorAll('details')];
    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        items.forEach((sibling) => {
          if (sibling !== item) sibling.open = false;
        });
      });
    });
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-ls-pdp-faq]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
